import useSWR from "swr";
import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { AttributeOption } from "../types";

interface RawAttribute {
  attributeId: number;
  attribute: string;
}

interface UseAttributesListResult {
  options: AttributeOption[];
  isLoading: boolean;
}

export const useAttributesList = (
  corporateId: string | number | undefined,
): UseAttributesListResult => {
  const url = corporateId
    ? `${ServicesURL.getAttributes}?corporateId=${corporateId}`
    : null;

  const { data, isLoading } = useSWR(url, (u: string) =>
    fetcher<any>(u, MethodType.GET),
  );

  const options: AttributeOption[] = (data?.enrollmentResponses ?? []).map(
    (el: RawAttribute) => ({ value: el.attributeId, label: el.attribute }),
  );

  return { options, isLoading };
};
